export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/infographic_design.73a699d.svg";